import React, { useContext } from "react";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState } from "../../../../../models/SKArtifact";
import { normalizeURL } from "../../../../../utils/stringFunctions";

interface Item {
  id: string;
  listImage: string;
  listTitle: string;
  listURL: string;
}

interface LayoutTableInputProps {
  items: Item[];
  editItemPopup: (id: string) => void;
  handleRemoveItem: (id: string) => void;
}

export const LayoutTableInput = ({ items, editItemPopup, handleRemoveItem }: LayoutTableInputProps) => {
  const { isEditable } = useContext(CreateArtifactContext);
  return (
    <table className="w-full">
      <tbody>
        {items.map((item, index) => (
          <tr key={index} className="border-b border-skseparatorgray h-[2px]">
            <td colSpan={2} className="py-[15px]">
              <div className="flex flex-row gap-[15px]">
                <div className="flex content-center justify-center">
                  <div className="relative items-center justify-center p-1 border-2 border-gray-200 border-separate w-[200px] h-[200px] max-w-[290px] max-h-[200px] rounded-md overflow-hidden">
                    <img src={item.listImage} alt={item.listTitle} className="object-cover w-full h-auto" />
                  </div>
                </div>
                <div className="items-start justify-start align-top">
                  <div className="list_item_title">{item.listTitle}</div>
                  <div className="list_item_sub_title">
                    <a
                      href={normalizeURL(item.listURL)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-500 underline hover:text-gray-700"
                    >
                      {item.listURL}
                    </a>
                  </div>
                </div>
                <div id="btns" className="flex max-w-[486px] mr-[5px] mt-[5px] ml-auto">
                  {isEditable && (
                    <div className="flex flex-col gap-[5px]">
                      <div className="content-center w-5 h-5 align-middle shadow-md top-2 right-1 rounded-3xl bg-slate-600">
                        <button className="top-0 left-0 right-0 w-5 h-5 text-white" onClick={() => handleRemoveItem(item.id)}>
                          ×
                        </button>
                      </div>
                      <div className="content-center w-5 h-5 align-middle shadow-md top-8 right-1 rounded-3xl bg-slate-600">
                        <button
                          className="flex items-center justify-center w-5 h-5 text-white rounded-full shadow-md bg-slate-600"
                          onClick={() => editItemPopup(item.id)}
                        >
                          ✎
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
